import { motion, AnimatePresence } from "framer-motion";
import { ProductCard } from "@/components/ProductCard";
import { FadeUp } from "@/components/Reveal";

export const Shop = ({ categories, products, active, setActive }) => {
  const tabs = [{ id: "all", name: "All" }, ...categories];
  const shown = active === "all" ? products : products.filter((p) => p.category === active);

  return (
    <section id="shop" data-testid="shop-section" className="px-5 py-24 md:px-10 md:py-32">
      <div className="mx-auto max-w-[1440px]">
        <FadeUp className="mb-10 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-lime">Shop</p>
            <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-5xl lg:text-7xl">The drop</h2>
          </div>
          <div className="flex flex-wrap gap-2" role="tablist">
            {tabs.map((t) => (
              <button key={t.id} onClick={() => setActive(t.id)} data-testid={`category-tab-${t.id}`} role="tab" aria-selected={active === t.id}
                className={`relative rounded-full border border-violet/50 px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-wider transition-colors ${active === t.id ? "text-ink" : "text-white hover:border-lime"}`}>
                {active === t.id && <motion.span layoutId="tab-pill" className="absolute inset-0 rounded-full bg-lime" transition={{ type: "spring", stiffness: 400, damping: 32 }} />}
                <span className="relative">{t.name}</span>
              </button>
            ))}
          </div>
        </FadeUp>
        {products.length === 0 ? (
          <p data-testid="shop-empty" className="text-haze">The drop is loading. Refresh if it takes too long.</p>
        ) : (
          <motion.div layout data-testid="product-grid" className="grid max-w-[1040px] grid-cols-1 gap-x-5 gap-y-12 sm:grid-cols-2">
            <AnimatePresence mode="popLayout">
              {shown.map((p) => <ProductCard key={p.id} product={p} />)}
            </AnimatePresence>
          </motion.div>
        )}
      </div>
    </section>
  );
};
